<template>
  <div >
    <div class="logo-wrap">
      <div><img :src="logo" alt=""></div>
      <div class="line"></div>
      <div><span>{{config.registeredServiceName||'统一身份认证'}}</span></div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'i18n',
    'config',

    'logo'
  ],
  data: function data() {
    return {
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
  },
  methods:{
  }
}
</script>
<style lang="scss" scoped>
.logo-wrap {
  position: absolute;
  top: 30px;
  left: 30px;
  padding: 9px 30px;
  background: rgba(255,255,255,0.7);
  backdrop-filter: blur(3px);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #222;
  font-size: 500;
  line-height: 40px;
  font-size: 28px;
  border-radius: 10px;
}
.logo-wrap img {
  height: 62px;
}
.logo-wrap .line {
  width: 1px ;
  height: 40px;
  background: #888888;
  margin: 0 21px;
}
@media  screen and (max-width: 1440px) {
  .logo-wrap {
    font-size: 20px;
  }
  .logo-wrap img {
    height: 44px
  }
}
  
</style>